import { RunwayModelsResponse } from '@/types';

export const UPDATE_ORG_CHECKLIST_ITEM_TEMPLATES = 'TRY_UPDATE_ORG_CHECKLIST_ITEM_TEMPLATES';

export interface TryUpdateOrgChecklistItemTemplates {
    type: typeof UPDATE_ORG_CHECKLIST_ITEM_TEMPLATES;
    payload: RunwayModelsResponse['orgChecklistItemTemplates'];
}

export const updateOrgChecklistItemTemplates = (
    payload: RunwayModelsResponse['orgChecklistItemTemplates'],
): TryUpdateOrgChecklistItemTemplates => {
    return {
        type: UPDATE_ORG_CHECKLIST_ITEM_TEMPLATES,
        payload: payload,
    };
};
